import { render, staticRenderFns } from "./orderCustomers.vue?vue&type=template&id=2f4629e3&scoped=true&"
import script from "./orderCustomers.vue?vue&type=script&lang=js&"
export * from "./orderCustomers.vue?vue&type=script&lang=js&"
import style0 from "./orderCustomers.vue?vue&type=style&index=0&id=2f4629e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4629e3",
  null
  
)

export default component.exports